export const FLOW_EXTRACT_PT_BR = {
	table: {
		description: "Descrição",
		value: "Valor",
		initialValue: "Saldo Inicial:",
		finalValue: "Saldo Final:",
		in: "Total de Entrada:",
		out: "Total de Saída:",
		item: {
			liquidationDate: "DATA DE LIQUIDAÇÃO",
			referenceDate: "DATA DE COMPETÊNCIA",
			groupName: "TIPO",
			originDestination: "ORIGEM/DESTINO",
			type: "TIPO",
			category: "CATEGORIA",
			observation: "OBSERVAÇÃO",
			value: "VALOR",
		},
	},
	excel: {
		title: "Relatório de Extrato",
		grouped: {
			day: "por dia",
			month: "por mês",
			type: "por tipo",
			category: "por categoria",
		},
	},
	search: "Buscar por...",
	yesterday: "Ontem",
	today: "Hoje",
	filter: {
		perType: "Por Tipo",
		noCategory: "Sem categoria",
	},
	accountRequired: "É necessário ter uma conta.",
	anticipated: "Antecipado",
	normalValue: "Valor Normal",
	anticipatedValue: "Valor Antecipado",
	dateTypeLabel: "Filtrar por",
	competence: "Competência",
	liquidation: "Liquidação",
	apply: "Aplicar",
};

export type FlowExtractPtBr = typeof FLOW_EXTRACT_PT_BR;
